'use strict';

/* eslint no-undef: "off" */
/**
 * ads product slider
 */
define('adsProductSlider',['baseSlider', 'jquery', 'GAReport'], function (baseSlider, $, GAReport) {
  return {
    template: '\n      <div class="in-ads-product in-container" v-if="show">\n        <div class="in-ads-title font-medium" v-if="productInfo.title_position">\n            <h2>\n              <div v-text="productInfo.name">\n              </div>\n            </h2>\n            <!--\n            <hr class="in-ads-hr" v-if="productInfo.relate_product.length < 2" />\n            -->\n        </div>\n        <div class="in-ads-subtitle" v-if="productInfo.relate_product.length > 1">\n            <div class="in-ads-subtitle-content" v-for="(item, index) in productInfo.relate_product" :class="{active: index === 0}">\n                <span v-text="item.name" @click.prevent="toggleTabs(index, $event)"></span>\n            </div>\n        </div>\n        <div class="in-ads-product-content" v-if="productInfo.relate_product.length > 0">\n        <keep-alive>\n          <base-slider :sliderConfig="sliderConfig" v-for="(item, index) in productInfo.relate_product" key="item.name" v-if="nowIndex === index">\n            <div class="swiper-slide in-product" v-for="(product, productIndex) in item.list">\n              <div class="in-ads-product-img">\n                <a :href="product.url_link" @click="onProductClicked(product, productIndex, item.name)">\n                    <img v-lazy="product.image"/>\n                </a>\n                <!--\n                <div class="in-flag-wrapper">\n                  <span v-if="product.sale_icon" class="in-sale-icon" v-text="i18n.sale"></span>\n                  <span v-if="product.new_icon" class="in-new-icon" v-text="i18n.new"></span>\n                </div>\n                -->\n              </div>\n              <div class="in-ads-product-info">\n                <div class="in-ads-product-name">\n                    <span v-text="product.name" :title="product.name"></span>\n                </div>\n                <div class="in-ads-product-price">\n                  <span class="in-price-final font-medium" v-html="product.final_price_label"></span>\n                  <span\n                    class="in-price-max"\n                    :class="[parseInt(product.max_price) > parseInt(product.final_price) ? \'final\' : \'font-medium\']"\n                    v-if="parseInt(product.max_price) > parseInt(product.final_price)"\n                    v-html="product.max_price_label">\n                  </span>\n                  <span v-if="parseInt(product.max_price) <= parseInt(product.final_price)"\n                    :style="{color: \'#fff\'}">none</span>\n                  <div class="in-ads-discount" v-if="parseInt(product.max_price) > parseInt(product.final_price)">\n                    <span>-{{Math.ceil((product.max_price - product.final_price)/product.max_price*100)}}%</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </base-slider>\n        </keep-alive>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        nowIndex: 0,
        show: false, // 控制productInfo.length > 0 才显示
        i18n: {
          new: 'New',
          sale: 'Sales'
        }
      };
    },

    props: {
      'productInfo': {
        type: Object,
        default: {},
        required: true
      },
      'page': {
        type: String,
        default: ""
      },
      'sliderConfig': {
        type: Object,
        default: function _default() {
          return {
            isPagination: true,
            isButtonPrev: false,
            isButtonNext: false,
            coreSliderConfig: {
              spaceBetween: 20,
              slidesPerView: 5,
              slidesPerGroup: 5,
              autoplay: {
                delay: 8000,
                disableOnInteraction: false
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              },
              observer: true,
              breakpoints: {
                3000: {
                  slidesPerView: 6,

                  spaceBetween: 20
                },
                1700: {
                  slidesPerView: 5,

                  spaceBetween: 20
                },
                1400: {
                  slidesPerView: 4,
                  spaceBetween: 20
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 20
                }
              }
            }
          };
        },
        required: false
      }
    },
    components: {
      baseSlider: baseSlider
    },

    watch: {
      productInfo: function productInfo(a) {
        console.log(a);
      }
    },
    mounted: function mounted() {
      this.init();
    },

    methods: {
      init: function init() {
        this.productInfo.relate_product[0].list.length > 0 ? this.show = true : this.show = false;

        this.reportProductExposure(this.productInfo.relate_product);
      },
      toggleTabs: function toggleTabs(index, event) {
        $(event.target).parent().parent().find('.in-ads-subtitle-content').removeClass('active');
        $(event.target).parent().addClass('active');
        this.nowIndex = index;
      },

      // 商品曝光
      reportProductExposure: function reportProductExposure(list) {
        var _this = this;

        (list || []).map(function (banner) {

          var eventAction = "";
          var eventCategory = "";
          var bannerName = "";
          if (_this.page === "home") {
            eventAction = 'HOME_PRODUCT_EXPOSURE_' + (banner.name || document.title).toUpperCase();
            eventCategory = 'HOME_PRODUCT_EXPOSURE_#VERSION#';
            bannerName = banner.name ? 'TAB_ ' + banner.name : 'TAB';
          } else if (_this.page === "pdp") {
            eventAction = 'PRODUCT_RECOMMAND_EXPOSURE_CLICK_' + (banner.name || document.title).toUpperCase();
            eventCategory = 'PRODUCT_RECOMMAND_EXPOSURE_#VERSION#';
            bannerName = "PRODUCT_RECOMMAND_EXPOSURE_" + banner.name;
          } else if (_this.page === "cart") {
            eventAction = 'CART_RECOMMAND_EXPOSURE_' + (banner.name || '').toUpperCase();
            eventCategory = 'CART_RECOMMAND_EXPOSURE_#VERSION#';
            bannerName = "CART_EXPOSURE_" + banner.name;
          } else {
            return false;
          }

          new GAReport().productExposure({
            'eventAction': eventAction,
            'eventCategory': eventCategory,
            'productList': new GAReport().productList(banner.list)
          });
        });
      },

      // 商品点击
      onProductClicked: function onProductClicked(data, index, bannerName) {
        var eventAction = "";
        var eventCategory = "";
        if (this.page === "home") {
          eventAction = 'HOME_PRODUCT_CLICK_' + (data.name || '').toUpperCase();
          eventCategory = 'HOME_PRODUCT_CLICK_#VERSION#';
          bannerName = bannerName ? 'TAB_ ' + bannerName : 'TAB';
        } else if (this.page === "pdp") {
          eventAction = 'PRODUCT_RECOMMAND_EXPOSURE_CLICK_' + (data.name || '').toUpperCase();
          eventCategory = 'PRODUCT_RECOMMAND_EXPOSURE_#VERSION#';
          bannerName = 'PRODUCT_RECOMMAND_EXPOSURE_ ' + bannerName;
        } else if (this.page === "cart") {
          eventAction = 'PRODUCT_RECOMMAND_EXPOSURE_CLICK_' + (data.name || '').toUpperCase();
          eventCategory = 'PRODUCT_RECOMMAND_EXPOSURE_#VERSION#';
          bannerName = 'CATY_EXPOSURE_ ' + bannerName;
        } else {
          return false;
        }

        new GAReport().productClick({
          'eventAction': eventAction,
          'eventCategory': eventCategory,
          'productList': [new GAReport().productItem(data, index)],
          'location': (bannerName || '').toUpperCase()
        });
      }
    }
  };
});
